import { useMemo } from "react";

import { useAuth } from "@/hooks/use-auth";

// NOTE: NSAI-6589 — the organization the ACTIVE project belongs to, or null in
// the personal project. Read from the project list the auth provider already
// holds, so it costs no request.
export const useActiveOrganizationUuid = (): string | null => {
  const { currentProjectUuid, projects } = useAuth();

  return useMemo(() => {
    if (!currentProjectUuid || !projects) return null;
    return (
      projects.organizationProjects.find((organization) =>
        organization.projects.some(
          (project) => project.uuid === currentProjectUuid,
        ),
      )?.uuid ?? null
    );
  }, [currentProjectUuid, projects]);
};
